(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/cylinder-wrapper/assets/prescript.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/cylinder-wrapper/assets/prescript.js');
'use strict';

svs.tb_ui_react = svs.tb_ui_react || {};
svs.tb_ui_react.cylinder_wrapper = svs.tb_ui_react.cylinder_wrapper || {};

 })(window);